module.exports = __webpack_public_path__ + "static/img/cylinder.3623377.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cylinder.png
// module id = Vv40
// module chunks = 1